import React from 'react';

import { Typography } from '@mui/material';
import { withStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import error404 from '../images/404.svg';

const StyledErrorContainer = styled.div`
    text-align: center;
`;

const StyledErrorMessage = withStyles(() => ({
    root: {
        textAlign: 'center'
    }
}))(Typography);

interface Error404Props {
    errorMessage?: string;
}

const Error404: React.FC<Error404Props> = ({ errorMessage }) => {
    const { t } = useTranslation('error_messages');

    const messageToUse = errorMessage ?? t('http-404.page-not-found');
    return (
        <StyledErrorContainer>
            <img src={error404}></img>
            <StyledErrorMessage variant="h4">{messageToUse}</StyledErrorMessage>
        </StyledErrorContainer>
    );
};

export default Error404;
